import React from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useHistory } from "react-router-dom";
import Wildcard from "../../../../services/wildcard";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UserDataForm from "../../global-elements/userDataForm";
import ColorCardChoiceForm from "../../global-elements/colorCardChoiceForm";
import ValidatorService from "../../../../services/validator";
import TTC from "../../add-ons/TTC";
import TC from "../../add-ons/TC";
import Esign from "../../add-ons/esign";
import marketing from "../../../../services/marketing";
import "../../../../assets/terms/dm-terms.css";
import Acknowledgements from "../../add-ons/Acknowledgements";
import CreditProtection from "../../add-ons/CreditProtection";
import { useEffect } from "react";
import ErrorModal from "../../../body/forms/components/ErrorModal";
import InvalidStateModal from "../../global-elements/invalidStateModal";
import PixelsService from '../../../../services/pixels';
import ConfirmSmsConsent from "../../global-elements/confirmsSmsConsent";
import Recaptcha from "../../../body/forms/components/recaptcha/Recaptcha";
import SubmitApplicationService from "../../../../services/submitApplication";
import Econsent from '../../global-elements/eConsent';
import FeaturesService from "../../../../services/features";
import AxiosWrapper from "../../../../services/axios";
import MfaSms from "../../global-elements/mfa/mfaSms";
import MfaEmail from "../../global-elements/mfa/mfaEmail";
import DeadEndMFa from "../../global-elements/mfa/deadEndMfa";
import AdobeScript from "../../../../services/adobeScript";
import OverlimitPrivilege from "../../add-ons/OverlimitPrivilege";
import { InactiveDetection } from "../../../../services/inactiveDetection";
import OutdatedUiVersion from "../../global-elements/outdatedUiVersion";
import AudioEyeSupport from "../../../../services/audioEyeSupport";
import { PRODUCT } from "../../../../models/websiteTypesConstants";

function Terms() {
  const useRecaptcha = useStoreState((state) => state.siteSettingsModel.useRecaptcha);
  const [recaptchaDisabled, setRecaptchaDisabled] = useState(true);
  const Setting = useStoreState((state) => state.siteSettingsModel);
  const setGrandBanckDeclined = useStoreActions(
    (actions) => actions.siteSettingsModel.setGrandBanckDeclined
  );

  const info = useStoreState((state) => state.applicantModel.applicant);
  const setInfo = useStoreActions(
    (actions) => actions.applicantModel.setApplicant
  );
  const text = useStoreState((state) => state.dmText.terms);
  const setApplicationResult = useStoreActions(
    (actions) => actions.applicationResultModel.setApplicationResult
  );
  const brandSettings = useStoreState(
    (state) => state.siteSettingsModel.brandSettings
  );
  const alResult = useStoreState(state => state.alResult);
  const setAlResult = useStoreActions(actions => actions.setAlResult);
  const Flow = useStoreState(state => state.siteSettingsModel.mainSettings.Flow);
  const WaterfallEvents = { "DM" : 10, "PREQUAL" : 6, "CFC" : 18, "STANDALONE" : 24, "CS" : 29};
  const resultStep = useStoreActions((actions) => actions.setDisplayResult);
  const setInvalidState = useStoreActions((actions) => actions.setInvalidState);
  const history = useHistory();
  const wildcard = new Wildcard();
  const validatorService = new ValidatorService();
  const methods = useForm({ mode: "onSubmit" });
  const [isLoading, setLoading] = useState(false);
  const utms = new marketing();
  const [errorShow, setErrorShow] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [showOutdatedUiVersionError, setShowOutdatedUiVersionError] = useState(false);
  const closeError = () => setErrorShow(false);
  const pendingInfo =  ["FROZEN", "FROZENPREQUAL", "PENDFEE", "PENDFUNDING", "PENDINFO", "PENDINTERNAL"];
  const getRoutingSettings = useStoreActions(state => state.routingSettingsModel.getRoutingSettings);
  const termsPixels = useStoreState(state => state.termsPixels);
  const setTermsPixel = useStoreActions(actions => actions.setTermsPixel);
  const PixelService = new PixelsService();
  const submitApplicationService = SubmitApplicationService();
  const setDeclineOffers = useStoreActions(actions => actions.siteSettingsModel.setDeclineOffers);
  const domain = useStoreState(state => state.siteSettingsModel.domain);
  const setMfaSms = useStoreActions(actions => actions.setMfaSms);
  const client = new AxiosWrapper()
  const adobeAds = new AdobeScript();
  const showOverlimit = wildcard.isFeatureEnabled('OverlimitSettings');
  const [tcHasErrors, setTcHasErrors] = useState(false);
  const isRecaptchaBlocking = Setting.productSettings.CaptchaKey !== null && recaptchaDisabled;
  const isDisabled = isLoading || tcHasErrors || isRecaptchaBlocking;

  InactiveDetection.setInactiveTitle("Make it count! Finish your application");

  useEffect(() => {
    if (!termsPixels) {
      PixelService.pageView("/Terms").event("google","DM","Terms");
      adobeAds.setup();
      setTimeout(() =>  adobeAds.startEvent('page_view'), 5000);
      setTermsPixel(true)
    }
    getRoutingSettings({ Url: Setting.domain, Route: window.location.pathname});
    setInfo({ index : 'Url', value : domain });
},[])

useEffect(() => {
  const validate = async () => {
      const isValidUiVersion = await validatorService.UiVersionValidate();
      setShowOutdatedUiVersionError(!isValidUiVersion);
  };

  validate();
},[])

const submit = async (data) => {
  setLoading(true)

  if (!validatorService.preValidations(data, methods, info) ) {
    if(await validatorService.EmailValidate(info.Email, methods)) {
      if(await validatorService.addressValidateV2(info, methods, setInvalidState) === true) {
        if(wildcard.isFeatureEnabled('MFAActive')) {
          let mfaId = await client.get('/mfa-id',{})
          sessionStorage.setItem('mfaId', mfaId);

          let result = await client.post('/send-Mfa', {
              contactIdentifier : info.PrimaryPhone,
              contactType : 'Text',
              ApplicantId : 0,
              WebUrl : Setting.domain
              }, true)
          if(result && result.Success === true){
              sessionStorage.setItem('sessionToken', result.Payload)
              setMfaSms(true)
              return
          }
          setErrorShow(true);
          setErrorMessage('An unknown error has occured. Please try again.')
          return
        } else {
          await submitApplication();
        }
      }
    }
  }

  setLoading(false);
}

  async function submitApplication() {

    const response = await submitApplicationService.submitApplication(info, true);
    const payload = response.Payload;

    if(response.Success){
      if (payload) {
        if (payload.IsGrandbank === true) {
          setGrandBanckDeclined(true);
        }

        if (payload.result != null) {
          //Marketing tracking
          utms.updateSessionReport( "appResult"  , payload.result.toUpperCase())
          utms.updateSessionReport( "applicantId", payload.ref_number || "");


          setDeclineOffers(payload.DeclineOffers || null);
          window.cl = payload.credit_limit ?? 0;
          setApplicationResult(payload);
          setInfo({ index: "step", value: 3 });
          resultStep(true);
          window.scrollTo(0, 0);

          if(payload.result.toUpperCase() === "PENDFEE" && Setting.brandSettings.ProductName.toLowerCase() === 'fit'){
            if(alResult === false){
              PixelService.pageView("/approved").approvedCalls(payload.ref_number)

              utms.trackEvent(WaterfallEvents[Flow] || 0, Flow, payload.ref_number, Setting.productSettings.ProductId, "Flow");

              setAlResult(true)
            }
            const url = "https://" + ((process.env.REACT_APP_CFC_APPLICANT_BUILDENV !== "PRODUCTION") ? "test" : "") +"offer.your"+brandSettings.ProductName.toLowerCase()+"card.com/payment/?RefNo="+payload.ref_number
            window.location.replace(url);
            return;
          }

          if (payload.result.toUpperCase() === "APPROVED") {

            history.push("/approved" + window.location.search);
            return;
          }
  
          //New Bank Account call for Dynamic call
          if(payload.result.toUpperCase() === 'PENDUSER') {
            history.push("/link-account" + window.location.search); return;
          }
          //--------------//

          if (pendingInfo.includes(payload.result.toUpperCase())) {
            history.push("/pendinfo" + window.location.search);
            return;
          }
          history.push("/decision" + window.location.search);
          return;
        }
      } else {
        setErrorMessage("An unknown error has occured. Please try again.");
        setErrorShow(true);
        setLoading(false);
      }
    } else if (payload.result.toUpperCase() === "INVALID_UI_VERSION") {
        setShowOutdatedUiVersionError(true);
        return;
    } else {
      payload.decline_message='We are currently processing your application, and you will receive a decision within 30 days.'
      setApplicationResult(payload);
      setInfo({ index: "step", value: 3 });
      resultStep(true);
      window.scrollTo(0, 0);
      history.push("decision" + window.location.search);
      return;
    }
  }

  const boldIf = (element, bold) => (bold ? (<b>{element}</b>) : element)

  return (
    <>
 {/*--- MFA stuff ---*/}
        {(wildcard.isFeatureEnabled('MFAActive')) && (
              <>
                  <MfaSms />
                  <MfaEmail />
                  <DeadEndMFa />
              </>

        )}
      {/*--- END MFA stuff ---*/}
      <InvalidStateModal />
      <div
        className={("row" + (brandSettings.ProductName === PRODUCT.Grand.bank ? " ribbonGB mb-0" : ""))}
        id="header-text-container"
        style={{ backgroundColor: Setting.brandSettings.Primary }}
      >
        <div className="col-12 text-center">
          <h1 id="offer-header-text" className="mt-2 mb-2">
            {wildcard.update().proccess(brandSettings.ProductName === PRODUCT.Grand.bank ? text.block1.grandBankTitleLineOne : text.block1.title)}<br/>
            {wildcard.update().proccess(brandSettings.ProductName === PRODUCT.Grand.bank ? text.block1.grandBankTitleLineTwo : '')}
          </h1>
        </div>
      </div>
      <div className="container mt-5 mb-5">
        <ErrorModal
          size="sm"
          show={errorShow}
          message={errorMessage}
          closeError={closeError}
        />
        {showOutdatedUiVersionError ?
            <OutdatedUiVersion />
        :
        <>
        {
          Setting.brandSettings.ProductName === PRODUCT.Grand.bank && (
            <div className="gb-limit-title mb-4 pl-2" style={{color: '#084B8A'}}>
              Fill out the information below
            </div>
          )
        }
          <FormProvider {...methods}>
            <form
              onSubmit={methods.handleSubmit(submit)}
            >
              <div className="dm-form">
                <UserDataForm />
              </div>
              {Setting.productSettings.ProductId === 1 || Setting.productSettings.ProductId === 10 ? (
                <div className="row">
                  <ColorCardChoiceForm />
                </div>
              ) : null}

              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">E-Sign Disclosure</h1>
                </div>
                <Esign />
              </div>
              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">Pricing and Terms</h1>
                </div>
                <div className="col-12 ">
                  <div className="terms-wrapper">
                    {info.IsRollUpCode ?
                      <TTC data={{ productCode: info.ProductCode }} />
                      :
                      <TC data={{ productCode: info.ProductCode }} onTermsErrorChange={setTcHasErrors} />
                    }
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">Credit Protection</h1>
                </div>
                <CreditProtection />
              </div>
            {showOverlimit && (
              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">Overlimit Privilege</h1>
                </div>
                <OverlimitPrivilege />
              </div>
            )}
              <div className="row">
                <div className="col-12">
                  <h1 className="terms-header-title">Acknowledgements</h1>
                </div>
                <Econsent />
                {Setting.smsConcentModuleDM === true && (
                  <div className="col-12 mb-3">
                      <div className="col-12">
                          <ConfirmSmsConsent></ConfirmSmsConsent>
                      </div>
                  </div>
              )}
                <Acknowledgements data={{ productCode: info.ProductCode }} />
              </div>
              <div className="row mt-3">
                  <div className="captcha-container">
                    {Setting.productSettings.CaptchaKey !== null ? (
                          <div className="form-group displayFlexCenter">
                          <Recaptcha
                              setRecaptchaDisabled={setRecaptchaDisabled}
                              ProductName={brandSettings.ProductName}
                          />
                          </div>
                      ) : (
                          <></>
                      )}
                  </div>
              </div>
              <div className="row mt-1">
                <div className="col-12 text-center">
                  <button
                    onClick={() => {
                      utms.trackEvent(11, "DM", "", Setting.productSettings.ProductId, "Flow");
                      PixelService.event("google", "DM", "Accept Offer");
                      adobeAds.event('form_submit',  Setting.CardColors.find(value => value.Code === info.cardColorCode))
                    }}
                    disabled={isDisabled}
                    id="dm-submit-app"
                    style={{
                      backgroundColor: Setting.brandSettings.Tertiary,
                      width: "17%",
                      color: "#fff",
                      minWidth: '350px'
                      }}
                  className="btn text-small mt-3 rounded"
                    type="submit"
                  >
                  {boldIf((isLoading ? "Submitting..." : (wildcard.isFeatureEnabled('MFAActive') ? 'Verify and Submit' : 'Submit Application')), Setting.brandSettings.ProductName === PRODUCT.Grand.bank)}
                  </button>
                </div>
              </div>
            </form>
          </FormProvider>
        </>}
      </div>


    </>
  );
}

export default Terms;